
const newModel = () => {
    return {
        tiendoGiainganId: null,
        duanDautuId: null,
        tenDuanDautu: null,
        ngayGiaingan: null,
        tinhhinhTrienkhai: null,
        vonGiaingan: null,
        uocLuyke: null,
        uocTrongnam: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null
    }
}

const newFEModel = () => {
    return {
        tiendoGiainganId: null,
        duanDautuId: null,
        ngayGiaingan: null,
        tinhhinhTrienkhai: null,
        vonGiaingan: null,
        uocLuyke: null,
        uocTrongnam: null,
        ghiChu: null,
        stt: "0",
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        tiendoGiainganId: item.tiendoGiainganId,
        duanDautuId: item.duanDautuId,
        tenDuanDautu: item.tenDuanDautu,
        ngayGiaingan: item.ngayGiaingan,
        tinhhinhTrienkhai: item.tinhhinhTrienkhai,
        vonGiaingan: item.vonGiaingan,
        uocLuyke: item.uocLuyke,
        uocTrongnam: item.uocTrongnam,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted
    }
}

const parseModeltoFEModel = (item) => {
    return {
        tiendoGiainganId: item.tiendoGiainganId,
        duanDautuId: item.duanDautuId,
        ngayGiaingan: item.ngayGiaingan,
        tinhhinhTrienkhai: item.tinhhinhTrienkhai,
        vonGiaingan: item.vonGiaingan,
        uocLuyke: item.uocLuyke,
        uocTrongnam: item.uocTrongnam,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        duanDautuId: null,
        ngayGiainganTungay: null,
        ngayGiainganDenngay: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        duanDautuId: item.duanDautuId,
        ngayGiainganTungay: item.ngayGiainganTungay,
        ngayGiainganDenngay: item.ngayGiainganDenngay,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        tiendoGiainganId: null,
        sttBaocao: null,
        ten: null,
        moTa: null,
        tiendoGiainganChaId: null,
        stt: null,
        enabled: null,
    }
}

export const tiendoGiainganModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    newPagingSearchModel,
    newSearchModel,
    fromJson,
    errors,
}


